var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "ml-4 mr-4" }, [
    _vm.type === "create"
      ? _c(
          "div",
          [
            _c("div", { staticClass: "row py-3 align-items-center" }, [
              _c("div", { staticClass: "col company-h1" }, [
                _c("button", {
                  staticClass: "btn btn-back",
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      _vm.setCompanyStep("companies-settings")
                    }
                  }
                }),
                _vm._v("\n        Create Company\n      ")
              ]),
              _vm._v(" "),
              _vm.$_can("companies.prices.store")
                ? _c("div", { staticClass: "col text-right" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary ld-ext-right",
                        class: _vm.loadingButton ? "running" : "",
                        attrs: { type: "button", disabled: _vm.buttonDisabled },
                        on: {
                          click: function($event) {
                            _vm.savePrices(_vm.pricing)
                          }
                        }
                      },
                      [
                        _vm._v("\n          Save\n          "),
                        _c("div", { staticClass: "ld ld-ball ld-flip" })
                      ]
                    )
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("companies-steps-menu", { attrs: { type: "create" } })
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.type === "edit"
      ? _c("div", [
          _c(
            "div",
            { staticClass: "row py-3 align-items-center company-header" },
            [
              _c(
                "div",
                { staticClass: "col-4" },
                [
                  _c("h2", { staticClass: "company-h1 mr-3" }, [
                    _c("button", {
                      staticClass: "btn btn-back",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          _vm.$router.push("/companies")
                        }
                      }
                    }),
                    _vm._v(
                      "\n          " + _vm._s(_vm.company.name) + "\n        "
                    )
                  ]),
                  _vm._v(" "),
                  _vm.company.status
                    ? [
                        _vm.company.status.name === "Active"
                          ? _c("span", { class: "btn-status btn-active" }, [
                              _vm._v(_vm._s(_vm.company.status.name))
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.company.status.name === "Inactive"
                          ? _c("span", { class: "btn-status btn-closed" }, [
                              _vm._v(_vm._s(_vm.company.status.name))
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.company.status.name === "Setup Incomplete"
                          ? _c(
                              "span",
                              { class: "btn-status btn-ncover info-company" },
                              [
                                _vm._v(
                                  _vm._s(_vm.company.status.name) +
                                    "\n            "
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "btn btn-link p-0 tippy-popup tippy-info",
                                    on: {
                                      mouseover: function($event) {
                                        _vm.showTooltipPrefix = true
                                      },
                                      mouseout: function($event) {
                                        _vm.showTooltipPrefix = false
                                      }
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fa fa-info-circle"
                                    })
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.showTooltipPrefix
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "popover tippy-info-popover"
                                      },
                                      [
                                        _vm._v(
                                          "\n              Setup incomplete is present when the company doesn't have one or more of the following: move sizes,\n              arrival windows, merchant account, rates and coverage.\n            "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            )
                          : _vm._e()
                      ]
                    : _vm._e()
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "col-8 d-flex align-items-center justify-content-end"
                },
                [
                  _vm.$_can("companies.review.request")
                    ? _c("companies-visibility-bar", {
                        attrs: { company: _vm.company },
                        on: {
                          saved: function($event) {
                            _vm.$emit("saved")
                          }
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary ld-ext-right ml-5",
                      class: _vm.loadingButton ? "running" : "",
                      attrs: { type: "button", disabled: _vm.buttonDisabled },
                      on: {
                        click: function($event) {
                          _vm.savePrices(_vm.pricing)
                        }
                      }
                    },
                    [
                      _vm._v("\n          Save\n          "),
                      _c("div", { staticClass: "ld ld-ball ld-flip" })
                    ]
                  )
                ],
                1
              )
            ]
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "row mb-3" }, [
      _c("div", { staticClass: "col-2 pr-1" }, [
        _c("div", { staticClass: "select-wrap amount-wrap" }, [
          _c("label", [_vm._v("Truck price")]),
          _vm._v(" "),
          _c("span", { staticClass: "dollar" }, [_vm._v("$")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.company.truck_price,
                expression: "company.truck_price"
              }
            ],
            staticClass: "form-control",
            attrs: {
              type: "text",
              placeholder: "Truck price",
              disabled: !_vm.$_can("companies.prices.store")
            },
            domProps: { value: _vm.company.truck_price },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.company, "truck_price", $event.target.value)
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-2 pr-1" }, [
        _c("div", { staticClass: "select-wrap amount-wrap" }, [
          _c("label", [_vm._v("Transaction fee")]),
          _vm._v(" "),
          _c("span", { staticClass: "dollar" }, [_vm._v("%")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.company.charge_fee,
                expression: "company.charge_fee"
              }
            ],
            staticClass: "form-control",
            attrs: {
              type: "text",
              placeholder: "Transaction fee",
              disabled: !_vm.$_can("companies.prices.store")
            },
            domProps: { value: _vm.company.charge_fee },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.company, "charge_fee", $event.target.value)
              }
            }
          })
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-7 border-right" },
        [
          _vm._m(0),
          _vm._v(" "),
          _vm.pricing.length > 0
            ? _vm._l(_vm.pricing, function(price, index) {
                return _c(
                  "div",
                  { key: "price-prefix-" + index, staticClass: "row" },
                  [
                    _c(
                      "div",
                      { staticClass: "col-2 pr-1" },
                      [
                        _c("div", { staticClass: "select-wrap" }, [
                          _c("label", [_vm._v("# of movers")]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.pricing[index].mover_number,
                                expression: "pricing[index].mover_number"
                              }
                            ],
                            staticClass: "form-control",
                            attrs: {
                              type: "text",
                              placeholder: "# of movers",
                              disabled: !_vm.$_can("companies.prices.store")
                            },
                            domProps: {
                              value: _vm.pricing[index].mover_number
                            },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.pricing[index],
                                  "mover_number",
                                  $event.target.value
                                )
                              }
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c("error-field", {
                          attrs: {
                            errors: _vm.errors,
                            field: index + ".mover_number"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-2 px-1" },
                      [
                        _c("div", { staticClass: "select-wrap amount-wrap" }, [
                          _c("label", [_vm._v("Price")]),
                          _vm._v(" "),
                          _c("span", { staticClass: "dollar" }, [_vm._v("$")]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.pricing[index].price,
                                expression: "pricing[index].price"
                              }
                            ],
                            staticClass: "form-control",
                            attrs: {
                              type: "text",
                              disabled: !_vm.$_can("companies.prices.store")
                            },
                            domProps: { value: _vm.pricing[index].price },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.pricing[index],
                                  "price",
                                  $event.target.value
                                )
                              }
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c("error-field", {
                          attrs: { errors: _vm.errors, field: index + ".price" }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-1 p-0 pt-4 text-center" }, [
                      _vm._v("\n            +\n          ")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-1" }, [
                      _c("div", {}, [
                        _c("label", [_vm._v("Truck price")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v("$ " + _vm._s(_vm.company.truck_price))
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-1 p-0 pt-4 text-center" }, [
                      _vm._v("\n            =\n          ")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-2 border-right" }, [
                      _c("div", {}, [
                        _c("label"),
                        _vm._v(" "),
                        _c("h4", [
                          _vm._v(
                            "\n                $ " +
                              _vm._s(
                                parseFloat(_vm.pricing[index].price) +
                                parseFloat(_vm.company.truck_price)
                                  ? parseFloat(_vm.pricing[index].price) +
                                    parseFloat(_vm.company.truck_price)
                                  : null
                              ) +
                              "\n              "
                          )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-2" },
                      [
                        _c("div", { staticClass: "select-wrap amount-wrap" }, [
                          _c("label", [_vm._v("Labor price")]),
                          _vm._v(" "),
                          _c("span", { staticClass: "dollar" }, [_vm._v("$")]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.pricing[index].labor,
                                expression: "pricing[index].labor"
                              }
                            ],
                            staticClass: "form-control",
                            attrs: {
                              type: "text",
                              disabled: !_vm.$_can("companies.prices.store")
                            },
                            domProps: { value: _vm.pricing[index].labor },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.pricing[index],
                                  "labor",
                                  $event.target.value
                                )
                              }
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c("error-field", {
                          attrs: { errors: _vm.errors, field: index + ".labor" }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.pricing.length > 1
                      ? _c("div", { staticClass: "col-1" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-clear mt-3",
                              attrs: {
                                disabled: !_vm.$_can("companies.prices.store")
                              },
                              on: {
                                click: function($event) {
                                  _vm.removePrice(index)
                                }
                              }
                            },
                            [_c("span", { staticClass: "mod-icon-clear" })]
                          )
                        ])
                      : _vm._e()
                  ]
                )
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.$_can("companies.prices.store")
            ? _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn add-button",
                      attrs: { type: "button" },
                      on: { click: _vm.addPricing }
                    },
                    [
                      _vm._m(1),
                      _vm._v("\n            Add Pricing Bracket\n          ")
                    ]
                  )
                ])
              ])
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-5 mileage-percentages" },
        [
          _c("div", { staticClass: "row mb-3" }, [
            _c("div", { staticClass: "col" }, [
              _vm._m(2),
              _vm._v(" "),
              _c("div", { staticClass: "row mb-3" }, [
                _c("div", { staticClass: "col" }, [
                  _c("div", { staticClass: "row mb-3" }, [
                    _c("div", { staticClass: "col" }, [
                      _c("div", { staticClass: "select-wrap amount-wrap" }, [
                        _c("label", [_vm._v("Service fee")]),
                        _vm._v(" "),
                        _c("span", { staticClass: "dollar" }, [_vm._v("$")]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.company.service_fee,
                              expression: "company.service_fee"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: {
                            type: "text",
                            placeholder: "Service fee",
                            disabled: !_vm.$_can("companies.prices.store")
                          },
                          domProps: { value: _vm.company.service_fee },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.company,
                                "service_fee",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col" }, [
                      _c("div", { staticClass: "select-wrap amount-wrap" }, [
                        _c("label", [_vm._v("Heavy items fee")]),
                        _vm._v(" "),
                        _c("span", { staticClass: "dollar" }, [_vm._v("$")]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.company.heavy_items_fee,
                              expression: "company.heavy_items_fee"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: {
                            type: "text",
                            placeholder: "Heavy items fee",
                            disabled: !_vm.$_can("companies.prices.store")
                          },
                          domProps: { value: _vm.company.heavy_items_fee },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.company,
                                "heavy_items_fee",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _vm._m(3),
          _vm._v(" "),
          _vm.$_can("companies.configurations.store")
            ? _c("div", [
                _c("div", { staticClass: "btn-group btn-group-toggle mb-3" }, [
                  _c(
                    "div",
                    {
                      on: {
                        click: function($event) {
                          _vm.toggleCalculationType(1)
                        }
                      }
                    },
                    [
                      _c("input", {
                        attrs: {
                          type: "radio",
                          name: "options",
                          autocomplete: "off"
                        },
                        domProps: {
                          checked: _vm.tempCompanyMileageTypeId === 1
                        }
                      }),
                      _vm._v(" Only deadhead length\n          ")
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      on: {
                        click: function($event) {
                          _vm.toggleCalculationType(2)
                        }
                      }
                    },
                    [
                      _c("input", {
                        attrs: {
                          type: "radio",
                          name: "options",
                          autocomplete: "off"
                        },
                        domProps: {
                          checked: _vm.tempCompanyMileageTypeId === 2
                        }
                      }),
                      _vm._v(" Entire job length\n          ")
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      on: {
                        click: function($event) {
                          _vm.toggleCalculationType(3)
                        }
                      }
                    },
                    [
                      _c("input", {
                        attrs: {
                          type: "radio",
                          name: "options",
                          autocomplete: "off"
                        },
                        domProps: {
                          checked: _vm.tempCompanyMileageTypeId === 3
                        }
                      }),
                      _vm._v(" Increase hourly rate\n          ")
                    ]
                  )
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.pricingLoading
            ? [
                _c(
                  "vue-content-loading",
                  { attrs: { width: 200, height: 150 } },
                  [
                    _c("rect", {
                      attrs: {
                        x: "0",
                        y: "0",
                        rx: "3",
                        ry: "3",
                        width: "70",
                        height: "10"
                      }
                    }),
                    _vm._v(" "),
                    _c("rect", {
                      attrs: {
                        x: "80",
                        y: "0",
                        rx: "3",
                        ry: "3",
                        width: "100",
                        height: "10"
                      }
                    }),
                    _vm._v(" "),
                    _c("rect", {
                      attrs: {
                        x: "190",
                        y: "0",
                        rx: "3",
                        ry: "3",
                        width: "10",
                        height: "10"
                      }
                    }),
                    _vm._v(" "),
                    _c("rect", {
                      attrs: {
                        x: "0",
                        y: "20",
                        rx: "3",
                        ry: "3",
                        width: "130",
                        height: "10"
                      }
                    }),
                    _vm._v(" "),
                    _c("rect", {
                      attrs: {
                        x: "155",
                        y: "20",
                        rx: "3",
                        ry: "3",
                        width: "130",
                        height: "10"
                      }
                    })
                  ]
                )
              ]
            : [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.company.mileage_calculation_type_id === 1,
                        expression: "company.mileage_calculation_type_id === 1"
                      }
                    ]
                  },
                  [
                    _c("h6", [
                      _vm._v(
                        "\n            Rate increase will calculate only the length when truck is running empty, deduct the free mileage and multiply the remaining distance with multiplier.\n          "
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.company.mileage_calculation_type_id === 2,
                        expression: "company.mileage_calculation_type_id === 2"
                      }
                    ]
                  },
                  [
                    _c("h6", [
                      _vm._v(
                        "\n            Rate increase will calculate the total miles for a move and multiply it with the percentage entered, giving you a dollar amount which is added on top of the price per hour.\n          "
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.company.mileage_calculation_type_id === 3,
                        expression: "company.mileage_calculation_type_id === 3"
                      }
                    ]
                  },
                  [
                    _c("h6", [
                      _vm._v(
                        "\n            Rate increase will calculate the entire length the truck travels. Multiplier you enter will create a percentage from the total miles, this percentage is then used to increase an hourly rate.\n          "
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _vm.company.mileage_calculation_type_id === 2
                  ? [
                      _vm.mileageConfigurations.length > 0
                        ? _vm._l(_vm.mileageConfigurations, function(
                            mileageConfiguration,
                            index
                          ) {
                            return _c(
                              "div",
                              {
                                key: "configuration-prefix-" + index,
                                staticClass: "row mb-3"
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "col-3" },
                                  [
                                    _c("div", { staticClass: "select-wrap" }, [
                                      _c("label", [_vm._v("From (m)")]),
                                      _vm._v(" "),
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.mileageConfigurations[index]
                                                .from,
                                            expression:
                                              "mileageConfigurations[index].from"
                                          }
                                        ],
                                        staticClass: "form-control",
                                        attrs: {
                                          type: "text",
                                          placeholder: "From",
                                          disabled: !_vm.$_can(
                                            "companies.prices.store"
                                          )
                                        },
                                        domProps: {
                                          value:
                                            _vm.mileageConfigurations[index]
                                              .from
                                        },
                                        on: {
                                          input: function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              _vm.mileageConfigurations[index],
                                              "from",
                                              $event.target.value
                                            )
                                          }
                                        }
                                      })
                                    ]),
                                    _vm._v(" "),
                                    _c("error-field", {
                                      attrs: {
                                        errors: _vm.errors,
                                        field: index + ".from"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "col-3" },
                                  [
                                    _c("div", { staticClass: "select-wrap" }, [
                                      _c("label", [_vm._v("To (m)")]),
                                      _vm._v(" "),
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.mileageConfigurations[index]
                                                .to,
                                            expression:
                                              "mileageConfigurations[index].to"
                                          }
                                        ],
                                        staticClass: "form-control",
                                        attrs: {
                                          type: "text",
                                          placeholder: "To",
                                          disabled: !_vm.$_can(
                                            "companies.prices.store"
                                          )
                                        },
                                        domProps: {
                                          value:
                                            _vm.mileageConfigurations[index].to
                                        },
                                        on: {
                                          input: function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              _vm.mileageConfigurations[index],
                                              "to",
                                              $event.target.value
                                            )
                                          }
                                        }
                                      })
                                    ]),
                                    _vm._v(" "),
                                    _c("error-field", {
                                      attrs: {
                                        errors: _vm.errors,
                                        field: index + ".to"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "col-3" },
                                  [
                                    _c("div", { staticClass: "select-wrap" }, [
                                      _c("label", [_vm._v("Percentage")]),
                                      _vm._v(" "),
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.mileageConfigurations[index]
                                                .percentage,
                                            expression:
                                              "mileageConfigurations[index].percentage"
                                          }
                                        ],
                                        staticClass: "form-control",
                                        attrs: {
                                          type: "text",
                                          placeholder: "%",
                                          disabled: !_vm.$_can(
                                            "companies.prices.store"
                                          )
                                        },
                                        domProps: {
                                          value:
                                            _vm.mileageConfigurations[index]
                                              .percentage
                                        },
                                        on: {
                                          input: function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              _vm.mileageConfigurations[index],
                                              "percentage",
                                              $event.target.value
                                            )
                                          }
                                        }
                                      })
                                    ]),
                                    _vm._v(" "),
                                    _c("error-field", {
                                      attrs: {
                                        errors: _vm.errors,
                                        field: index + ".percentage"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-3" }, [
                                  _vm.mileageConfigurations.length > 1
                                    ? _c("div", { staticClass: "col-1" }, [
                                        _c(
                                          "button",
                                          {
                                            staticClass: "btn btn-clear mt-3",
                                            attrs: {
                                              disabled: !_vm.$_can(
                                                "companies.prices.store"
                                              )
                                            },
                                            on: {
                                              click: function($event) {
                                                _vm.removeMileageConfiguration(
                                                  index
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _c("span", {
                                              staticClass: "mod-icon-clear"
                                            })
                                          ]
                                        )
                                      ])
                                    : _vm._e()
                                ])
                              ]
                            )
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.$_can("companies.prices.store")
                        ? _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col" }, [
                              _c(
                                "button",
                                {
                                  staticClass: "btn add-button",
                                  attrs: { type: "button" },
                                  on: { click: _vm.addMileageConfiguration }
                                },
                                [
                                  _vm._m(4),
                                  _vm._v(
                                    "\n                Add Bracket\n              "
                                  )
                                ]
                              )
                            ])
                          ])
                        : _vm._e()
                    ]
                  : [
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-6" }, [
                          _c(
                            "div",
                            { staticClass: "select-wrap amount-wrap" },
                            [
                              _c("label", [_vm._v("Mileage multiplier")]),
                              _vm._v(" "),
                              _c("span", { staticClass: "percent" }, [
                                _vm._v("%")
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.company.mileage_multiplier,
                                    expression: "company.mileage_multiplier"
                                  }
                                ],
                                staticClass: "form-control",
                                attrs: {
                                  type: "text",
                                  placeholder: "Mileage multiplier",
                                  disabled: !_vm.$_can("companies.prices.store")
                                },
                                domProps: {
                                  value: _vm.company.mileage_multiplier
                                },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.company,
                                      "mileage_multiplier",
                                      $event.target.value
                                    )
                                  }
                                }
                              })
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-6" }, [
                          _c("div", { staticClass: "select-wrap" }, [
                            _c("label", [_vm._v("Free mileage")]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.company.free_mileage,
                                  expression: "company.free_mileage"
                                }
                              ],
                              staticClass: "form-control",
                              attrs: {
                                type: "text",
                                placeholder: "Free mileage",
                                disabled: !_vm.$_can("companies.prices.store")
                              },
                              domProps: { value: _vm.company.free_mileage },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.company,
                                    "free_mileage",
                                    $event.target.value
                                  )
                                }
                              }
                            })
                          ])
                        ])
                      ])
                    ]
              ]
        ],
        2
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col" }, [
        _c("div", { staticClass: "l-header-2" }, [_vm._v("Pricing")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [_c("span", { staticClass: "mod-icon-add" })])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row mb-3" }, [
      _c("div", { staticClass: "col" }, [
        _c("div", { staticClass: "l-header-2" }, [
          _vm._v("Additional expenses")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col" }, [
        _c("div", { staticClass: "l-header-2" }, [
          _vm._v("Mileage calculation")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [_c("span", { staticClass: "mod-icon-add" })])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ed861462", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ed861462","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/companies/CompaniesPricing.vue
// module id = null
// module chunks = 